import { useCallback, useMemo, useState } from 'react'
import { Button, Dropdown, Modal, Tooltip, type MenuProps } from 'antd'
import { CheckOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, PlusOutlined, ReloadOutlined, SaveOutlined } from '@ant-design/icons'
const ICONS = { add: <PlusOutlined aria-hidden />, edit: <EditOutlined aria-hidden />, remove: <DeleteOutlined aria-hidden />,
  more: <EllipsisOutlined aria-hidden />, reload: <ReloadOutlined aria-hidden />, save: <SaveOutlined aria-hidden />, apply: <CheckOutlined aria-hidden /> }
const TRIGGERS: ('click')[] = ['click']
export const CanvasToolbar = ({ disabled, canAdd, changed, canActivate,
  onAdd, onMetadata, onReload, onSave, onActivate, onDelete }: {
  disabled: boolean; canAdd: boolean; changed: boolean; canActivate: boolean
  onAdd: () => void; onMetadata: () => void
  onReload: () => void; onSave: () => void; onActivate: () => void; onDelete: () => void
}) => {
  const [deleteOpen, setDeleteOpen] = useState(false)
  const openDelete = useCallback(() => setDeleteOpen(true), [])
  const closeDelete = useCallback(() => setDeleteOpen(false), [])
  const confirmDelete = useCallback(() => { if (!disabled) onDelete(); closeDelete() }, [closeDelete, disabled, onDelete])
  const items = useMemo<MenuProps['items']>(() => [
    { key: 'metadata', label: '流程信息', icon: ICONS.edit, disabled },
    { key: 'reload', label: '重新读取', icon: ICONS.reload, disabled },
    { type: 'divider' },
    { key: 'delete', label: '删除流程', icon: ICONS.remove, danger: true, disabled },
  ], [disabled])
  const menuClick = useCallback<NonNullable<MenuProps['onClick']>>(({ key }) => {
    if (disabled) return
    const actions: Record<string, () => void> = { metadata: onMetadata, reload: onReload, delete: openDelete }
    actions[key]?.()
  }, [disabled, onMetadata, onReload, openDelete])
  const menu = useMemo(() => ({ items, onClick: menuClick }), [items, menuClick])
  return <div role="toolbar" aria-label="流程操作" className="instance-administration__canvas-toolbar">
    <Button icon={ICONS.add} onClick={onAdd} disabled={disabled || !canAdd}>新增步骤</Button>
    <Tooltip title="保存草稿"><Button icon={ICONS.save} aria-label="保存草稿" onClick={onSave} disabled={disabled || !changed} /></Tooltip>
    <Tooltip title="设为当前角色流程"><Button icon={ICONS.apply} type="primary" aria-label="设为当前角色流程" onClick={onActivate} disabled={disabled || changed || !canActivate}>启用</Button></Tooltip>
    <Dropdown menu={menu} trigger={TRIGGERS} placement="bottomRight" disabled={disabled}>
      <Button icon={ICONS.more} aria-label="更多流程操作" disabled={disabled} />
    </Dropdown>
    <Modal title="删除此流程草稿？当前启用的流程不能删除。" open={deleteOpen} onCancel={closeDelete} onOk={confirmDelete} okText="删除" cancelText="取消" />
  </div>
}
